import { render, staticRenderFns } from "./property-buyer-names.vue?vue&type=template&id=6c1e8f9c"
import script from "./property-buyer-names.vue?vue&type=script&lang=js"
export * from "./property-buyer-names.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports